export default "__VITE_ASSET__zUAn2YnQ__"